module.exports = __webpack_public_path__ + "img/10.0c09b8b6.jpg";